"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Payment = void 0;
var react_1 = __importDefault(require("react"));
var Payment = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg" }, props),
    react_1.default.createElement("g", null,
        react_1.default.createElement("path", { d: "M31.6666 23.3333V9.99996C31.6666 8.16663 30.1666 6.66663 28.3333 6.66663H4.99996C3.16663 6.66663 1.66663 8.16663 1.66663 9.99996V23.3333C1.66663 25.1666 3.16663 26.6666 4.99996 26.6666H28.3333C30.1666 26.6666 31.6666 25.1666 31.6666 23.3333ZM28.3333 23.3333H4.99996V9.99996H28.3333V23.3333ZM16.6666 11.6666C13.9 11.6666 11.6666 13.9 11.6666 16.6666C11.6666 19.4333 13.9 21.6666 16.6666 21.6666C19.4333 21.6666 21.6666 19.4333 21.6666 16.6666C21.6666 13.9 19.4333 11.6666 16.6666 11.6666ZM38.3333 11.6666V30C38.3333 31.8333 36.8333 33.3333 35 33.3333H6.66663C6.66663 31.6666 6.66663 31.8333 6.66663 30H35V11.6666C36.8333 11.6666 36.6666 11.6666 38.3333 11.6666Z", fill: "currentColor" })))); };
exports.Payment = Payment;
